module.exports = require("./ccp.js");